import { TOKENS } from '@/constants/accessTokens'

function getAccessToken(key = TOKENS.access) {
    return localStorage.getItem(key)
}

function setAccessToken(token, key = TOKENS.access) {
    return localStorage.setItem(key, token)
}

function removeAccessTokens() {
    localStorage.removeItem(TOKENS.access)
    localStorage.removeItem(TOKENS.homer)
}

export {
    getAccessToken,
    setAccessToken,
    removeAccessTokens,
}
